<template>
  <div class="bar-separator"></div>
</template>